/* eslint-disable */ import { applicationConfigComponent, canvasCustomEnvironmentComponent, fitRootPerspectiveCameraComponent, memoEval } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const rootEntityComponents = [
    attachComponent.withComponent(applicationConfigComponent, 'default', true).withAlias('RootEntity').attach(memoEval(()=>[], ()=>({
            layout: 'universal',
            shareStrategy: 'current-frontend',
            distanceDataUnit: 'inch',
            initialGlobalUnit: 'inch',
            availableDimensions: [
                'inch'
            ],
            initialIndicatorShown: false,
            unitDisplayConfig: {
                inch: {
                    strategy: 'fraction',
                    fractionBasis: [
                        2,
                        4
                    ]
                }
            },
            availableLocales: [
                'en'
            ]
        }))),
    attachComponent.withComponent(applicationConfigComponent, 'readOnly', true).withAlias('RootEntity').withGradualFilter({
        modes: [
            'read'
        ]
    }).attach(memoEval(()=>[], ()=>({
            ignoreSelectionInSidebar: true
        }))),
    attachComponent.withComponent(canvasCustomEnvironmentComponent, 'default', true).withAlias('RootEntity').attach(memoEval(()=>[], ()=>({
            name: 'SceneEnvironment'
        }))),
    attachComponent.withComponent(fitRootPerspectiveCameraComponent, 'default', true).withAlias('RootEntity').attach(memoEval(()=>[], ()=>({
            priority: 1,
            fov: 35,
            near: 1,
            far: 10000,
            polarAngle: Math.PI / 2.5,
            minPolarAngle: Math.PI * 0.1,
            maxPolarAngle: Math.PI / 2.2,
            distance: 250,
            minDistance: 100,
            maxDistance: 500,
            azimuthAngle: Math.PI / 8 * -1
        })))
];

//# sourceMappingURL=root-entity.js.map